import { JWT } from '../interfaces';
import { LoginSessionLoadError } from '../errors';

export class JWTLoginSessionStore {
    private readonly STORAGE_KEY = 'INFINITE_JWT';

    /**
     * Clean session store.
     */
    public clean(): void {
        localStorage.removeItem(this.STORAGE_KEY);
    }

    /**
     * Load current session from the store.
     */
    public read(): JWT {
        const cachedData = localStorage.getItem(this.STORAGE_KEY);
        if (cachedData !== null) {
            return cachedData as JWT;
        }
        throw new LoginSessionLoadError();
    }

    /**
     * Save token to the store.
     * It will overwrite previous session token.
     */
    public write(jwt: JWT) {
        localStorage.setItem(this.STORAGE_KEY, jwt);
    }
}
